import * as createjs from 'createjs-module';
function fetchChoices(api, canvasName) {
  var choices = [];
  const url = api + '/api/philosophy_wheel/' + canvasName;
  var request = new XMLHttpRequest();
  request.open('GET', url, false);  // `false` makes the request synchronous
  request.send(null);

  if (request.status === 200) {
    choices = JSON.parse(request.responseText);
  }
  return choices

}

export function drawWheelCanvas(canvasName, choices) {
  function tick(event) {
    stage.update(event);
  }
  var c = new createjs.Container();
  var segments = 0,
    angle = 0;
  var bottomNum = null;

  var stage = new createjs.Stage(canvasName);
  console.log(document.getElementById(canvasName));
  // The entire canvas
  createjs.Ticker.timingMode = createjs.Ticker.RAF;
  createjs.Ticker.on("tick", tick);
  // Use tick mode

  var s = new createjs.Shape();
  var size = 250;
  segments = choices.length;
  angle = Math.PI * 2 / segments;

  // Draw a wheel  
  for (var i = 0, l = segments; i < l; i++) {
    var centerAngle = angle * i;
    var startAngle = centerAngle - 0.5 * angle;


    s.graphics.f((i % 2 == 0) ? "#bbb" : "#ddd")
      .mt(0, 0)
      .lt(Math.cos(startAngle) * size, Math.sin(startAngle) * size)
      .arc(0, 0, size, startAngle, startAngle + angle)
      .lt(0, 0);

    // Add text child
    var num = new createjs.Text(choices[i], (size / 8) + "px Arial Black", "#888")
      .set({ textAlign: "right", regX: -size + 20, regY: size / 16, rotation: angle / Math.PI * 180 * i });
    c.addChild(num);
  }
  c.addChildAt(s, 0);
  c.x = c.y = size + 20;
  c.cache(-size, -size, size * 2, size * 2);
  // c.rotation = -360 / segments / 2; // Rotate by 1/2 segment to align at 0

  // Red Notch
  var notch = new createjs.Shape();
  notch.x = c.x + size + 15;
  notch.y = c.y;
  notch.graphics.f("red").drawPolyStar(0, 0, 12, 3, 2, 180);

  // Where the wheel should land
  bottomNum = new createjs.Text("", "50px Arial", "#000")
    .set({ x: c.x, y: c.y + size + 10, textAlign: "center" });


  stage.addChild(c, notch, bottomNum);
  stage.update();

  // Mode. 0=stopped, 1=moving
  c.mode = 0;
  c.on("click", function (event) {
    // Stopped
    if (c.mode == 0) {
      c.mode = 1;


      // Slow down. Find the end angle, and tween to it
      var num = Math.random() * segments | 0, // Choose a number,
        angleR = angle * 180 / Math.PI, // Angle in degrees
        adjusted = (c.rotation - 360),	// Add to the current rotation
        numRotations = Math.ceil(adjusted / 360) * 360 - num * angleR; // Find the final number.



      createjs.Tween.get(c)
        .to({ rotation: numRotations }, 3000, createjs.Ease.cubicOut)
        .call(function () {
          c.mode = 0;
          bottomNum.text = choices[num]; // Show the end number
        });
    }
  })

}
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

export function work(canvasName, choices) {
  waitForElm('.wheel').then((e)=>drawWheelCanvas(canvasName, choices))
}